// removed by extract-text-webpack-plugin
module.exports = {"root":"SectionList--root--Xs","fixed":"SectionList--fixed--an","list":"SectionList--list--3W","item":"SectionList--item--2U","itemActive":"SectionList--itemActive--1g","filter":"SectionList--filter--N2","disabled":"SectionList--disabled--3r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionList/styles.styl
// module id = 865
// module chunks = 0